var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProfileDown(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_16356_71939",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_16356_71939)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.99935 12.4798C9.88824 12.4798 9.78407 12.4625 9.68685 12.4277C9.58963 12.393 9.49935 12.334 9.41602 12.2507L5.58268 8.41732C5.4299 8.26454 5.35352 8.0701 5.35352 7.83398C5.35352 7.59787 5.4299 7.40343 5.58268 7.25065C5.73546 7.09787 5.9299 7.02148 6.16602 7.02148C6.40213 7.02148 6.59657 7.09787 6.74935 7.25065L9.99935 10.5007L13.2493 7.25065C13.4021 7.09787 13.5966 7.02148 13.8327 7.02148C14.0688 7.02148 14.2632 7.09787 14.416 7.25065C14.5688 7.40343 14.6452 7.59787 14.6452 7.83398C14.6452 8.0701 14.5688 8.26454 14.416 8.41732L10.5827 12.2507C10.4993 12.334 10.4091 12.393 10.3118 12.4277C10.2146 12.4625 10.1105 12.4798 9.99935 12.4798Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileDown);
export default __webpack_public_path__ + "static/media/profile_down.2d340badfb8863d0faf7b8c11ef94190.svg";
export { ForwardRef as ReactComponent };